import {
	Campaign,
	CampaignAdvertisement,
	CampaignPayment,
	SlotResults,
	LocationResult,
	AdvertisementAsset,
} from '@horasys/bellplus/common/types';
import { Advertisement } from '@horasys/bellplus/common/types';
import { getClientFromJson } from '../../jsonutils/client';
import { getAdvertisementFromJson } from '../../jsonutils/advertisement';
import moment from 'moment';
import { Client } from '@horasys/bellplus/common/types';
import { getPrimaryAsset } from '../../services/advertising.service';
export const getCampaignFromJson = (json: any): Campaign => {
	const campaign: Campaign = {} as Campaign;

	// try{
	campaign.id = json.id;
	campaign.client = {} as Client;
	campaign.client = getClientFromJson(json.clientDetails);
	campaign.status = json.campaignStatus;
	campaign.price = json.campaignCost;
	campaign.paymentReceived = json.paymentReceived;
	campaign.campaignAdvertisements = [];
	campaign.payments = [];
	campaign.name = json.campaignName;
	campaign.originalName = json.campaignName;
	campaign.campaignPaymentDetailsResponse = json.campaignPaymentDetailsResponse;
	campaign.campaignAdvertisementDetailsResponse =
		json.campaignAdvertisementDetailsResponse;
	const discountPercentage = json.discountPercentage;
	const campaignCostWithoutDiscount = json.campaignCostWithoutDiscount;
	const campaignAdvertisements = json.campaignAdvertisementDetailsResponse;

	campaignAdvertisements.forEach((campAd: any) => {
		const campaignAdvertisement: CampaignAdvertisement = {} as CampaignAdvertisement;
		campaignAdvertisement.id = campAd.id;
		campaignAdvertisement.advertisement = {} as Advertisement;
		if (campAd.advertisementResponse) {
			campaignAdvertisement.advertisement = getAdvertisementFromJson(
				campAd.advertisementResponse,
			);
		}
		const adAsset: AdvertisementAsset = getPrimaryAsset(
			campaignAdvertisement.advertisement,
		);

		if (adAsset.type === 'video') {
			campaignAdvertisement.previewUrl = adAsset.url;
			campaignAdvertisement.thumbnailUrl = adAsset.thumbnailAsset?.url;
		} else if (adAsset.type === 'image') {
			campaignAdvertisement.previewUrl = adAsset.url;
			campaignAdvertisement.thumbnailUrl = adAsset.url;
		} else if (adAsset.type === 'multipleImages') {
			if (adAsset.children && adAsset.children.length) {
				campaignAdvertisement.previewUrl = adAsset.children[0].url;
				campaignAdvertisement.thumbnailUrl = adAsset.children[0].url;
			}
		}

		campaignAdvertisement.startDate = moment(
			moment(campAd.startDate).format('YYYY-MM-DD'),
		).toDate();
		campaignAdvertisement.endDate = moment(
			moment(campAd.endDate).format('YYYY-MM-DD'),
		).toDate();
		campaignAdvertisement.uuid = campAd.uuid;
		campaignAdvertisement.userBudget = campAd.userBudget;
		campaignAdvertisement.calculatedBudget = campAd.calculatedBudget;
		campaignAdvertisement.noOfTimes = campAd.noOfTimes;
		campaignAdvertisement.selectedLocations = [];
		campaignAdvertisement.selectedLocationGroups = [];
		if (campAd.locationDetails) {
			campAd.locationDetails.forEach((loc: any) => {
				const locationDetail: LocationResult = {} as LocationResult;
				locationDetail.noOfTimes = loc.noOfTimes;
				locationDetail.selectedDeviceCount = loc.selectedDeviceCount;
				locationDetail.budget = loc.budget;
				if (loc.type === 'ML') {
					campaignAdvertisement.typeOfSearch = 'location';
				} else if (loc.type === 'LG') {
					campaignAdvertisement.typeOfSearch = 'locationGroup';
				}
				if (loc.mainLocationDetails) {
					locationDetail.name = loc.mainLocationDetails.locationName;
					locationDetail.city = loc.mainLocationDetails.city;
					locationDetail.area = loc.mainLocationDetails.area;
					locationDetail.address = loc.mainLocationDetails.address;
				}
				if (campaignAdvertisement.typeOfSearch === 'location')
					campaignAdvertisement.selectedLocations.push(locationDetail);
				else if (campaignAdvertisement.typeOfSearch === 'locationGroup')
					campaignAdvertisement.selectedLocationGroups.push(locationDetail);
			});
		}

		campaign.campaignAdvertisements.push(campaignAdvertisement);
	});

	const paymentDetails = json.campaignPaymentDetailsResponse;

	const paymentJson = paymentDetails[0];

	const payment: CampaignPayment = {} as CampaignPayment;
	payment.id = paymentJson.id;
	payment.description = paymentJson.paymentDescription;
	payment.amount = paymentJson.paymentAmount;
	payment.method = paymentJson.paymentMethod;
	payment.option = paymentJson.paymentOption;
	payment.dueDate =
		paymentJson.dueDate &&
		moment(moment(paymentJson.dueDate).format('YYYY-MM-DD')).toDate();

	payment.index = 0;
	payment.discount = discountPercentage;
	payment.totalAmount = campaignCostWithoutDiscount;

	payment.status = paymentJson.status;
	campaign.payments.push(payment);

	return campaign;
};

export const getJsonFromCampaign = (campaign: Campaign): any => {
	const json: any = {};

	json.campaignName = campaign.name;
	json.clientId = campaign.client.id;
	json.campaignCost = campaign.price;
	json.advertisements = [];

	campaign.campaignAdvertisements.forEach((campAd: CampaignAdvertisement) => {
		const campAdJson = {} as any;
		campAdJson.advertisementId = campAd.advertisement.id;
		campAdJson.startDate = moment(campAd.startDate).format('YYYY-MM-DD');
		campAdJson.endDate = moment(campAd.endDate).format('YYYY-MM-DD');
		campAdJson.noOfTimes = campAd.noOfTimes;
		campAdJson.uuid = campAd.uuid;
		campAdJson.automatic = campAd.isAuto;
		campAdJson.userBudget = campAd.userBudget;
		json.advertisements.push(campAdJson);
	});

	json.payments = [];
	campaign.payments.forEach((payment: CampaignPayment) => {
		const paymentJson = {} as any;
		if (payment.id) {
			paymentJson.paymentDescription = payment.description;
			paymentJson.paymentOption = payment.option;
			paymentJson.paymentAmount = payment.amount;
			paymentJson.paymentMethod = payment.method;
			paymentJson.dueDate =
				payment.dueDate && moment(payment.dueDate).format('YYYY-MM-DD');
			paymentJson.requestId = payment.id;
			paymentJson.action = 'update';
			json.payments.push(paymentJson);
		} else {
			paymentJson.paymentDescription = payment.description;
			paymentJson.paymentOption = payment.option;
			paymentJson.paymentAmount = payment.amount;
			paymentJson.paymentMethod = payment.method;
			paymentJson.dueDate =
				payment.dueDate && moment(payment.dueDate).format('YYYY-MM-DD');
			paymentJson.action = 'create';
			json.payments.push(paymentJson);
		}
	});

	json.discountPercentage = campaign.payments[0].discount
		? campaign.payments[0].discount.toString()
		: '0';
	json.campaignCostWithoutDiscount = campaign.payments[0].totalAmount.toString();

	return json;
};

export const getSlotResultsFromJson = (json: any): SlotResults => {
	const slotResults = {} as SlotResults;
	slotResults.budget = json.budget;
	slotResults.uuid = json.uuid;
	slotResults.locations = [];
	json.locations.forEach((loc: any) => {
		const locationResult = {} as LocationResult;
		locationResult.address = loc.address;
		locationResult.area = loc.area;
		locationResult.budget = loc.budget;
		locationResult.name = loc.locationName;
		locationResult.noOfTimes = loc.noOfTimes;
		locationResult.city = loc.city;
		locationResult.selectedDeviceCount = loc.selectedDeviceCount;
		slotResults.locations.push(locationResult);
	});
	return slotResults;
};

export const getAllCampaignDatesInArray = (campaignJsonObject: any) => {
	const datesInISOArray: any = [];
	console.warn(
		'ADV COUNT',
		campaignJsonObject.campaignAdvertisementDetailsResponse.length,
	);
	console.warn('CAMPAIGN ID', campaignJsonObject.id);
	campaignJsonObject.campaignAdvertisementDetailsResponse.forEach((ad: any) => {
		datesInISOArray.push(ad.startDate);
		datesInISOArray.push(ad.endDate);
	});
	return datesInISOArray;
};

export const getCampaignDatesInArray = (campaignJsonObject: any) => {
	const datesInISOArray: any = [];

	campaignJsonObject.campaignAdvertisementDetailsResponse.forEach((ad: any) => {
		datesInISOArray.push(ad.startDate);
		datesInISOArray.push(ad.endDate);
	});
	return datesInISOArray;
};
